import { useLocation } from "react-router-dom";
import { useUserContext } from "../../contexts/userContext";
import { dataMenu, dataMenuCustomerArea } from "../../data/dataMenu";
import { Card } from "../ui/Card";

const SectionCard = () => {
  const { role, departments, billingContact, sc_UserToCustomerFile } =
    useUserContext();
  const location = useLocation();
  const isCustomerArea = location.pathname.includes("customer-area");

  const dataMenuFilter = isCustomerArea
    ? // Si l'utilisateur est dans l'espace client
      dataMenuCustomerArea.filter((item) => {
        // Toujours retourner Dashboard
        if (item.title === "Dashboard") {
          return true;
        }

        // Vérifier les permissions pour Social
        if (item.title === "Social") {
          return sc_UserToCustomerFile.length > 0;
        }

        // Vérifier les permissions pour Factures
        if (item.title === "Factures") {
          return billingContact === true;
        }

        // Par défaut, ne pas afficher les autres éléments
        return false;
      })
    : dataMenu.filter((item) => {
        // Si l'utilisateur a le département SOCIAL ou est Admin/Direction, il peut voir la brique Social
        if (item.title === "Social") {
          return (
            departments.includes("SOCIAL") ||
            role === "Admin" ||
            role === "Direction"
          );
        }

        // Filtre par rôle pour les autres briques
        if (role === "Lecteur") {
          return (
            item.title !== "Trésorerie" &&
            item.title !== "CRM" &&
            item.title !== "Staff" &&
            item.title !== "Paramètres"
          );
        } else if (role === "Editeur" || role === "Superviseur") {
          return (
            item.title !== "Trésorerie" &&
            item.title !== "CRM" &&
            item.title !== "Staff" &&
            item.title !== "Paramètres"
          );
        } else if (role === "Comptabilité") {
          return (
            item.title !== "CRM" &&
            item.title !== "Staff" &&
            item.title !== "Paramètres"
          );
        } else if (role === "Admin") {
          return true;
        } else if (role === "Direction") {
          return true;
        }

        // Par défaut, retourne tous les éléments
        return true;
      });

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
      {dataMenuFilter?.map((item) => (
        <Card
          key={item.id}
          title={item.title}
          icon={item.icon}
          description={item.description}
          link={item.link}
        />
      ))}
    </div>
  );
};

export default SectionCard;
